import React, { Component } from 'react';
import Plus from 'sushiweb/Icons/all/Plus';
import { clone, findIndex, propEq, isEmpty, find } from 'ramda';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";
import ExclamationLine from 'sushiweb/Icons/all/ExclamationLine'

import CommonHeaderComponent from "../../headers/CommonHeaderComponent";
import './AssetTracking.scss';
import AssetCard from './AssetCard';
import { ASSET_PROTO, TRANSACTION_TYPE, USER_TYPE } from './../../../operations/constants';
import { getAssetsType, saveAssets, getOrderAssets, clearAssetDeleteError} from './../../../actions/assetsActions';
import { getOrderDetails } from './../../../actions/ordersAction';
import PictureModeModal from './../../core/PictureModeModal';
import ModalComponent from './../../core/ModalComponent';
import * as symbols from "../../../operations/symbols";

class AssetTracking extends Component {
  constructor() {
    super();
    this.state = {
      assetDetails: [clone(ASSET_PROTO)],
      delivered: [],
      recieved: [],
      activeIndex: 0,
      showInvoiceModal: false, 
      skipSave: true
    }
  }

  componentDidMount = async () => {
    const orderId = this.props.match.params.id;
    this.props.actions.getOrderAssets(orderId);
    this.props.actions.getAssetsType();
    this.props.actions.getOrderDetails(orderId);
  }

  componentDidUpdate = (prevProps) => {
    const { getOrdersAssetStatus } = this.props;
    if(getOrdersAssetStatus !== prevProps.getOrdersAssetStatus && getOrdersAssetStatus === symbols.STATUS_DONE) {
      this.initializeState();
    }
  }

  initializeState = () => {
    let { delivered, recieved } = this.state;
    const { uploadedAssets } = this.props;
      const mappedAssets = this.mapUploadedAssets(clone(uploadedAssets)) || [];
      mappedAssets.forEach(asset => {
        delivered.push(asset.deliveredQuantity);
        recieved.push(asset.recievedQuantity)
      });
      if(mappedAssets.length > 0) {
        this.setState({ assetDetails: mappedAssets, activeIndex: null, recieved, delivered });
      }
      
  }

  addAnotherAsset = () => {
    let { assetDetails, activeIndex } = this.state;
    activeIndex = assetDetails.length;
    assetDetails.push(clone(ASSET_PROTO));
    this.setState({ assetDetails: assetDetails, activeIndex: activeIndex });
  }

  changeAssetDetails = (value, field, index) => {
    let { assetDetails, delivered, recieved, skipSave } = this.state;
    assetDetails[index][field] = value;
    if (field === "deliveredQuantity") {
      if (isNaN(value)) {
        return;
      }
      delivered[index] = Number(value);
    }
    if (field === "recievedQuantity") {
      if (isNaN(value)) {
        return;
      }
      recieved[index] = Number(value);
    }
    if(skipSave) {
      this.setState({skipSave: false})
    }
    this.setState({ assetDetails: assetDetails, delivered: delivered, recieved: recieved });
  }

  disableAddAnother = () => {
    const { assetDetails } = this.state;
    if (assetDetails.length) {
      let lastAssetUpdated = assetDetails[assetDetails.length - 1];
      const { assetName, deliveredQuantity, recievedQuantity } = lastAssetUpdated;
      if (assetName === "Select Asset Type" || deliveredQuantity === "" || recievedQuantity === "") {
        return true;
      }
      return false;
    }
  }

  getTotalAssetsCount = () => {
    const { delivered, recieved } = this.state;
    const deliverdAssets = delivered.reduce((acc, value) => { return acc + value }, 0)
    const recievedAssets = recieved.reduce((acc, value) => { return acc + value }, 0)
    return { deliverdAssets, recievedAssets };
  }

  showActiveIndex = (index) => {
    const { activeIndex } = this.state;
    if (activeIndex === index) {
      this.setState({ activeIndex: null });
    } else {
      this.setState({ activeIndex: index });
    }
  }

  disableDone = () => {
    const { assetDetails } = this.state;
    if (assetDetails.length) {
      if (assetDetails.length === 1) {
        return this.disableAddAnother();
      } else {
        let lastAssetUpdated = assetDetails[assetDetails.length - 1];
        const { assetName, deliveredQuantity, recievedQuantity } = lastAssetUpdated;
        if ((assetName !== "Select Asset Type" && deliveredQuantity !== "" && recievedQuantity !== "") ||
          (assetName === "Select Asset Type" && deliveredQuantity === "" && recievedQuantity === "")
        ) {
          return false;
        } else {
          return true;
        }
      }
    }
  }

  mapUploadedAssets = (uploadedAssets) => {
    let mappedAssets = [];
    uploadedAssets.forEach(asset => {
      const mappedIndex = findIndex(propEq('assetName', asset.assetName))(mappedAssets);
      if (mappedIndex >= 0) {
        if (asset.transactionType === TRANSACTION_TYPE.CREDIT) {
          mappedAssets[mappedIndex].deliveredQuantity = asset.quantity;
        } else if (asset.transactionType === TRANSACTION_TYPE.DEBIT) {
          mappedAssets[mappedIndex].recievedQuantity = asset.quantity;
        }
      } else {
        let newMapping = clone(ASSET_PROTO);
        newMapping.assetName = asset.assetName;
        newMapping.deliveredQuantity = 0;
        newMapping.recievedQuantity = 0;
        if (asset.transactionType === TRANSACTION_TYPE.CREDIT) {
          newMapping.deliveredQuantity = asset.quantity;
        } else if (asset.transactionType === TRANSACTION_TYPE.DEBIT) {
          newMapping.recievedQuantity = asset.quantity;
        }
        mappedAssets.push(newMapping);
      }
    });
    return mappedAssets;
  }

  formatAssetDetails = (assetDetails) => {
    let mappedAssedDetails = [];
    assetDetails.forEach(assetDetail => {
      if (assetDetail.assetName !== "Select Asset Type") {
        
          mappedAssedDetails.push({ assetName: assetDetail.assetName, quantity: Number(assetDetail.deliveredQuantity), transactionType: TRANSACTION_TYPE.CREDIT });
          mappedAssedDetails.push({ assetName: assetDetail.assetName, quantity: Number(assetDetail.recievedQuantity), transactionType: TRANSACTION_TYPE.DEBIT });
      }
    })
    return mappedAssedDetails;
  }

  saveAssets = () => {
    const orderId = this.props.match.params.id;
    const { assetDetails, skipSave } = this.state;
    const { saveAssets } = this.props.actions;
    const mappedAssests = this.formatAssetDetails(assetDetails);
    if(!skipSave) {
      saveAssets(orderId, mappedAssests);
    }
    this.goToNextScreen();
  }

  goToNextScreen = () => {
    const orderId = this.props.match.params.id;
    let invoiceImages = this.props.orderDetails.images.reduce((acc, ele) => {
      if (ele.entityType === 'invoice' && ele.userType === USER_TYPE.DA) {
        acc.push(ele)
      }
      return acc
    }, []);
    if (invoiceImages.length === 0) {
      this.setState({ showInvoiceModal: true })
    } else {
      this.props.history.push({
        pathname: '/order/' + orderId + "/invoice",
        state: { id: orderId, images: invoiceImages, orderNumber: this.props.location.state.orderNumber }
      })
    }
  }

  closePictureModeModal() {
    const orderId = this.props.match.params.id;
    this.props.actions.getOrderAssets(orderId);
    this.setState({ showInvoiceModal: false });
  }

  onDelete = (index) => {
    let { assetDetails, delivered, recieved } = this.state;
    let deletedAssetIndex = assetDetails[index];
    const isAssetUploaded = this.isAssetUploaded(index);
    if(!isAssetUploaded) {
      assetDetails.splice(index,1);
      if(deletedAssetIndex.deliveredQuantity) {
        delivered.splice(index, 1);
      }
      if(deletedAssetIndex.recievedQuantity) {
        recieved.splice(index, 1);
      }
      this.setState({assetDetails: assetDetails,delivered, recieved});
    } 
  }

  filterAssetTypes = (assetTypes) => {
    const { uploadedAssets } = this.props;
    const { assetDetails } = this.state;

    if(uploadedAssets.length === 0) {
      const isAssetUploaded = assetDetails.filter(assetDetail => assetDetail !== ASSET_PROTO) || [];
      if(!isAssetUploaded.length === 0) {
        return assetTypes;
      }
    }
    let selectedAssets = [];
    uploadedAssets.forEach(asset => {
      if( !selectedAssets.includes(asset.assetName)) {
        selectedAssets.push(asset.assetName)
      }
    });
    assetDetails.forEach(asset => {
      if( !selectedAssets.includes(asset.assetName)) {
        selectedAssets.push(asset.assetName)
      }
    })
    const notSelected =  assetTypes.filter(asset => !selectedAssets.includes(asset.value));
    return notSelected;
  }

  closeErrorModal = () => {
    this.props.actions.clearAssetDeleteError();
  }

  renderAssetError = (error) => {
    return (
      <div className="fs-16">{error}</div>
    )
  }

  renderErrorTitle = () => {
    return(
      <div className="flex red-text"><ExclamationLine className="icon-medium icon-color-red mr-2"/> Error</div>
    )
  }

  isAssetUploaded = (index) => {
    let { assetDetails } = this.state;
    let { uploadedAssets = {} } = this.props;
    let deletedAssetIndex = assetDetails[index];
    const isAssetUploaded = find(propEq('assetName', deletedAssetIndex.assetName))(uploadedAssets);
    if(isAssetUploaded && !isEmpty(isAssetUploaded)) {
      return true;
    }
    return false;
  }

  render() {
    const { assetDetails, activeIndex, showInvoiceModal } = this.state;
    const { assetTypes, deleteAssetError } = this.props;
    const totalAssets = this.getTotalAssetsCount() || {};
    const disableAddAnother = this.disableAddAnother();
    const disableDone = this.disableDone();
    const orderId = this.props.match.params.id;
    return (
      <div>
        { deleteAssetError && <ModalComponent isOpen={true} onClose={() => this.closeErrorModal()} title={this.renderErrorTitle()} body={this.renderAssetError(deleteAssetError)}></ModalComponent>}
        <CommonHeaderComponent title="Asset Check" enableBack={true}/>
        <PictureModeModal
          isOpen={showInvoiceModal}
          closePictureModeModal={() => this.closePictureModeModal()}
          id={orderId}
          orderNumber={this.props.location.state.orderNumber}
          type={'invoice'}
          title={'Upload Invoice'}
          images={this.props.location.state.images}
          redirectedURL={`/order/${orderId}/invoice`}
          modalBody={() => {
            return <div className="center mt-neg-2">
              <p className="fs-16 mb-2 align-left">
                Please take an image of the invoice and make sure that the amount and items are clearly visible
              </p>
              <img src="../../images/invoiceSample.png" />
            </div>
          }}
        />
        <div className='accordian-head'>
          <h4 className="w-400 fs-14">Please add count for all assets given to merchant </h4>
          {assetDetails.map((assetDetail, index) => {
            return (
              <AssetCard
                assetDetail={assetDetail}
                assetTypes={assetTypes}
                filteredAssetList={ this.filterAssetTypes(assetTypes)}
                key={index}
                onChange={this.changeAssetDetails}
                index={index}
                showForm={index === activeIndex ? true : false}
                onDelete={(index, isUploaded) => this.onDelete(index, isUploaded) }
                showDelete={ assetDetails.length !== 1}
                isUploaded={this.isAssetUploaded(index)}
                showActiveIndex={(index) => this.showActiveIndex(index)} />
            )
          })
          }
          {assetDetails.length !== assetTypes.length && <div className={disableAddAnother ? "disabled flex fs-14" : "flex fs-14 green-text"} onClick={() => this.addAnotherAsset()}>
            <Plus className={disableAddAnother ? "icon-size-small icon-color-gray mr-1" : "icon-size-small icon-color-green mr-1"}></Plus>Add another asset
          </div>}
        </div>
        <div className="order-card fixed-verify-section z-index-9">
          <div>
            Delivered: <b>{totalAssets.deliverdAssets}</b> <br />
            Recieved: <b>{totalAssets.recievedAssets}</b>
          </div>
          <div className={disableDone ? "btn btn-sm btn-disabled" : "btn btn-sm btn-green"}
            onClick={() => this.saveAssets()}>Done</div>
        </div>
      </div>
    )
  }
}

const actions = { getAssetsType, saveAssets, getOrderAssets , getOrderDetails, clearAssetDeleteError}
export default withRouter(connect(
  state => ({
    assetTypes: state.assets.assetsType || [],
    uploadedAssets: state.assets.orderAssets || [],
    orderDetails: state.orders.orderDetails || {},
    deleteAssetError: state.assets.deleteAssetError || "",
    getOrdersAssetStatus: state.statuses.getOrderAssets.status
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(AssetTracking));
